// INCLUDES
import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";

// Vue-Headful to allow modifying of the Title
/*import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);*/

Vue.config.productionTip = false;

// VUE-Carousel 
import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);

// FONT AWESOME - used for icons
import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon.vue";
Vue.component("Icon", Icon);

// V-TOOLTIP - used for tooltips on I icons.
const VTooltip = require("v-tooltip");
Vue.use(VTooltip);

// Include Moment - for date manipulation
Vue.use(require("vue-moment"));

// LOCALIZATION
import messages from "@/language";
import VueI18n from "vue-i18n";
import getLocale from "@/utils/getLocale";

const locale=getLocale();
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale, // set locale
  messages // set locale messages
});

// Initialize components
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import StepHeader from "./components/StepHeader.vue";
import BottomNav from "./components/BottomNav.vue";
import StepWrapper from "./components/StepWrapper.vue";
Vue.component("header-view", Header);
Vue.component("footer-view", Footer);
Vue.component("stepheader-view", StepHeader);
Vue.component("bottomnav-view", BottomNav);
Vue.component("stepwrapper-view", StepWrapper);

// Create the main Vue
const vm = new Vue({
  i18n,
  el: "#app",
  router,
  store,
  data: {
    showModal: false
  },
  render: (h) => h(App)
});
